import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AdminPodcastForm from './AdminPodcastForm';
import AdminImagePreviewModal from './AdminImagePreviewModal'; // Import the new modal

const AdminPodcastManager = () => {
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [editingItemId, setEditingItemId] = useState(null);

    // State for the image preview modal
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState('');

    const fetchItems = async () => {
        setIsLoading(true);
        const token = localStorage.getItem('app_token');
        const response = await axios.get('/api/admin/podcasts', { headers: { Authorization: `Bearer ${token}` } });
        setItems(response.data);
        setIsLoading(false);
    };

    useEffect(() => { fetchItems(); }, []);

    const handleSave = async (formData) => {
        const token = localStorage.getItem('app_token');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const url = editingItemId ? `/api/admin/podcasts/${editingItemId}` : '/api/admin/podcasts';
        const method = editingItemId ? 'put' : 'post';
        await axios[method](url, formData, config);
        fetchItems();
        setIsFormOpen(false);
        setEditingItemId(null);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this podcast?')) {
            const token = localStorage.getItem('app_token');
            await axios.delete(`/api/admin/podcasts/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            fetchItems();
        }
    };

    const handleOpenPreview = (imageUrl) => {
        setPreviewImageUrl(imageUrl);
        setIsPreviewModalOpen(true);
    };

    const handleClosePreview = () => {
        setIsPreviewModalOpen(false);
        setPreviewImageUrl('');
    };
    
    if (isLoading) return <p>Loading podcasts...</p>;

    return (
        <div className="admin-content-manager">
            {isPreviewModalOpen && (
                <AdminImagePreviewModal imageUrl={previewImageUrl} onCancel={handleClosePreview} />
            )}
            {isFormOpen && <AdminPodcastForm podcastId={editingItemId} onSave={handleSave} onCancel={() => { setIsFormOpen(false); setEditingItemId(null); }} />}
            <div className="admin-content-header">
                <h3 className="admin-section-title">Manage Podcasts</h3>
                <button onClick={() => { setEditingItemId(null); setIsFormOpen(true); }} className="btn-primary">Add New Podcast</button>
            </div>
            <div className="admin-table-container">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Thumbnail</th>
                            <th>Title</th>
                            <th>Category</th>
                            <th>Author</th>
                            <th>Tags</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(item => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>
                                    <div onClick={() => handleOpenPreview(item.thumbnail_url)} style={{ cursor: 'pointer' }}>
                                        <img src={item.thumbnail_url} alt="Thumbnail" className="admin-table-thumbnail" />
                                    </div>
                                </td>
                                <td>
                                    <Link to={`/podcasts/${item.id}`} target="_blank" rel="noopener noreferrer">
                                        {item.title}
                                    </Link>
                                </td>
                                <td>{item.category}</td>
                                <td>{item.author_name}</td>
                                <td>{item.tags}</td>
                                <td className="admin-table-actions">
                                    <button onClick={() => { setEditingItemId(item.id); setIsFormOpen(true); }} className="action-btn edit"><span className="material-icons">edit</span></button>
                                    <button onClick={() => handleDelete(item.id)} className="action-btn delete"><span className="material-icons">delete_forever</span></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminPodcastManager;